import React, { FC } from 'react';
import { MyVehicleItem } from 'api/vehicles';
import { FirstPlateSeparatorIcon, SecondPlateSeparatorIcon } from 'common/icons';
import clsx from 'classnames';

import styles from './plate.module.scss';

export const VehiclePlate: FC<{ vehicle: MyVehicleItem }> = ({ vehicle }) => {
  // @ts-ignore
  const [one, two, three] = vehicle.plate.match(/.{1,2}/g).slice();

  return (
    <div className={clsx(styles.container, styles.vehicle)}>
      <span>
        {one} <FirstPlateSeparatorIcon /> {two} <SecondPlateSeparatorIcon /> {three}
      </span>
      <span>CHILE</span>
    </div>
  );
};
